import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { holidaysUrl } from './constants';
import type { HolidayQueryParams } from './useHolidays';
import { getHolidayYearQueryParams } from './useHolidays';

export default function prefetchHolidays(
  client: APIClient,
  queryParams: HolidayQueryParams = getHolidayYearQueryParams(),
) {
  return prefetchQuery(holidaysUrl, client, {
    queryParams,
  });
}
